// extracted by mini-css-extract-plugin
export default {"page":"styles_page__kL5Y2","main":"styles_main__KtLuK","form":"styles_form__wswUb","alert":"styles_alert__04K1+","disclaimer":"styles_disclaimer__k2Gdi"};